import { Component } from '@angular/core'
import { OrderSummaryComponent } from '@spartacus/cart/base/components'
import { EbCart } from '../../interface/eb-cart.interface'

@Component({
    selector: 'eb-order-summary',
    templateUrl: './eb-order-summary.component.html',
    styleUrls: ['./eb-order-summary.component.scss'],
    standalone: false
})
export class EbOrderSummaryComponent extends OrderSummaryComponent {
  cart: EbCart = {}
}
